import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React from 'react';
import { SubmitHandler } from 'react-hook-form';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../../../../context/auth';
import { permissions, PermissionsKeyedShape } from '../../../../../permissions';
import RolesAPI, { RoleCreateRequest } from '../../api/roles';
import {
	ROLES_ADD_ROLE_HEADER,
	ROLE_BREADCRUMB_ADD,
	ROLE_BREADCRUMB_HOME,
} from '../../data/constants';
import { RoleForm } from './components';
import { RoleCreateForm } from './components/RoleForm';

const AddRole = () => {
	const { tenantHostname } = useParams();
	const navigate = useNavigate();
	const authData = useAuthContext();
	const authToken = authData?.tenantAuthorizationData?.authorizationToken;
	const tenantId = authData?.tenantAuthorizationData?.tenantId;

	const permissionDefaults = Object.keys(permissions).reduce(
		(acc, key: keyof PermissionsKeyedShape) => {
			acc[key] = [];
			return acc;
		},
		{} as PermissionsKeyedShape,
	);

	const { mutate } = RolesAPI.useCreateRole(
		[RolesAPI.ROLES_KEY, tenantId || tenantHostname],
		tenantHostname,
		authToken,
		() =>
			tenantHostname
				? navigate(`/admin/tenants/${tenantHostname}/roles`)
				: navigate('/admin/roles'),
	);

	const onSubmit: SubmitHandler<RoleCreateForm> = (data) => {
		const createRequest = {} as RoleCreateRequest;
		createRequest.name = data.name;
		createRequest.displayName = data.displayName;
		createRequest.permissions = [];
		Object.keys(data).forEach((key: keyof RoleCreateForm) => {
			if (key !== 'name' && key !== 'permissions' && key !== 'displayName') {
				createRequest.permissions = createRequest.permissions.concat(data[key]);
			}
		});

		mutate(createRequest);
	};

	return (
		<>
			<Breadcrumbs aria-label='breadcrumb'>
				<Link
					component={NavLink}
					underline='hover'
					color='inherit'
					to={
						tenantHostname
							? `/admin/tenants/${tenantHostname}/roles`
							: '/admin/roles'
					}
				>
					{ROLE_BREADCRUMB_HOME()}
				</Link>
				<Typography color='text.primary'>{ROLE_BREADCRUMB_ADD()}</Typography>
			</Breadcrumbs>
			<RoleForm
				onSubmit={onSubmit}
				formTitle={ROLES_ADD_ROLE_HEADER()}
				permissions={permissions}
				permissionDefaults={permissionDefaults}
			/>
		</>
	);
};

export default AddRole;
